export default __webpack_public_path__ + "static/media/scrollToTop.666e20fe.svg";